// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v1.users.properties.rentguarantee.RentalManagerUserPropertyRentGuaranteeWebApiHandler

import { getClient } from '../../client';
import { httpFrontEndRequest } from '@zg-rentals/ts-client-http-client';

import type {
  CreateStripeSetupIntentByPolicyIdRequestDto,
  CreateStripeSetupIntentResponseDto,
  GetPremiumPaymentDashboardDataResponseDto,
  GetRentalProtectionPolicyCostByPolicyIdResponseDto,
  GetSecureClaimsUrlForPolicyResponseDto,
  ListingAlias,
  LowFrictionStatusDto,
  RentalManagerRentGuaranteeDisclaimerRequestDto,
  RentGuaranteeDisclaimersDto,
  RentGuaranteeDropPolicyWebApiRequestDto,
  RentGuaranteeListingStateResponseDto,
  RentGuaranteePageResponseDto,
  RentTermDto,
  RetrieveStoredPaymentMethodsResponseDto,
  SavePolicyPaymentMethodRequestDto,
} from '../..';

interface CheckForActivePaymentTermParams {
  policyId: string;
}
interface GetLowFrictionStatusParams {
  listingAlias: ListingAlias;
}
interface GetPremiumPaymentDashboardDataParams {
  policyId: string;
}
interface GetRentalProtectionManagePageMultiplePoliciesParams {
  disclaimerType?: string;
  listingAlias: ListingAlias;
  stepOffset?: number;
}
interface GetRentalProtectionPolicyCostByPolicyIdParams {
  policyId: string;
}
interface GetRentalProtectionStateForListingMultiPolicyParams {
  listingAlias: ListingAlias;
}
interface GetSecureClaimsUrlForPolicyParams {
  listingAlias: ListingAlias;
  policyId: string;
}

export const RentalManagerUserPropertyRentGuaranteeWebApiHandler_checkForActivePaymentTerm_Path =
  '/api/web/v1/users/properties/rentGuarantee/checkForActivePaymentTerm';

/**
 * check for active payment term for a policy
 * @deprecated
 */
export const RentalManagerUserPropertyRentGuaranteeWebApiHandler_checkForActivePaymentTerm = (
  getParams: CheckForActivePaymentTermParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<CheckForActivePaymentTermParams, never, RentTermDto>(
    {
      getParams: getParams,
      endpoint: RentalManagerUserPropertyRentGuaranteeWebApiHandler_checkForActivePaymentTerm_Path,
      method: 'GET',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerUserPropertyRentGuaranteeWebApiHandler_createSetupIntent_Path =
  '/api/web/v1/users/properties/rentGuarantee/stripe/createSetupIntent';

/**
 * get stripe setup intent for policy
 * @deprecated
 */
export const RentalManagerUserPropertyRentGuaranteeWebApiHandler_createSetupIntent = (
  postData: CreateStripeSetupIntentByPolicyIdRequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, CreateStripeSetupIntentByPolicyIdRequestDto, CreateStripeSetupIntentResponseDto>(
    {
      endpoint: RentalManagerUserPropertyRentGuaranteeWebApiHandler_createSetupIntent_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
      postData: postData,
    },
    client,
  );
};

export const RentalManagerUserPropertyRentGuaranteeWebApiHandler_dropRentalProtectionPolicy_Path =
  '/api/web/v1/users/properties/rentGuarantee/dropRentalProtectionPolicy';

/**
 * drop rental protection policy and remove experiment stored data
 * @deprecated
 */
export const RentalManagerUserPropertyRentGuaranteeWebApiHandler_dropRentalProtectionPolicy = (
  postData: RentGuaranteeDropPolicyWebApiRequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, RentGuaranteeDropPolicyWebApiRequestDto, void>(
    {
      endpoint: RentalManagerUserPropertyRentGuaranteeWebApiHandler_dropRentalProtectionPolicy_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
      postData: postData,
    },
    client,
  );
};

export const RentalManagerUserPropertyRentGuaranteeWebApiHandler_getDisclaimers_Path =
  '/api/web/v1/users/properties/rentGuarantee/getDisclaimers';

/**
 * get rental protection disclaimer[s]
 * @deprecated
 */
export const RentalManagerUserPropertyRentGuaranteeWebApiHandler_getDisclaimers = (
  postData: RentalManagerRentGuaranteeDisclaimerRequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, RentalManagerRentGuaranteeDisclaimerRequestDto, RentGuaranteeDisclaimersDto>(
    {
      endpoint: RentalManagerUserPropertyRentGuaranteeWebApiHandler_getDisclaimers_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
      postData: postData,
    },
    client,
  );
};

export const RentalManagerUserPropertyRentGuaranteeWebApiHandler_getLowFrictionStatus_Path =
  '/api/web/v1/users/properties/rentGuarantee/getLowFrictionStatus';

/**
 * get low friction status for listing
 * @deprecated
 */
export const RentalManagerUserPropertyRentGuaranteeWebApiHandler_getLowFrictionStatus = (
  getParams: GetLowFrictionStatusParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<GetLowFrictionStatusParams, never, LowFrictionStatusDto>(
    {
      getParams: getParams,
      endpoint: RentalManagerUserPropertyRentGuaranteeWebApiHandler_getLowFrictionStatus_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerUserPropertyRentGuaranteeWebApiHandler_getPremiumPaymentDashboardData_Path =
  '/api/web/v1/users/properties/rentGuarantee/stripe/getPremiumPaymentDashboardData';

/**
 * get premium payment dashboard data
 * @deprecated
 */
export const RentalManagerUserPropertyRentGuaranteeWebApiHandler_getPremiumPaymentDashboardData = (
  getParams: GetPremiumPaymentDashboardDataParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<GetPremiumPaymentDashboardDataParams, never, GetPremiumPaymentDashboardDataResponseDto>(
    {
      getParams: getParams,
      endpoint: RentalManagerUserPropertyRentGuaranteeWebApiHandler_getPremiumPaymentDashboardData_Path,
      method: 'GET',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerUserPropertyRentGuaranteeWebApiHandler_getRentalProtectionManagePageMultiplePolicies_Path =
  '/api/web/v1/users/properties/rentGuarantee/getRentalProtectionManagePageMultiplePolicies';

/**
 * Get rental protection manage page with multiple policies for listing
 * @deprecated
 */
export const RentalManagerUserPropertyRentGuaranteeWebApiHandler_getRentalProtectionManagePageMultiplePolicies = (
  getParams: GetRentalProtectionManagePageMultiplePoliciesParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<GetRentalProtectionManagePageMultiplePoliciesParams, never, RentGuaranteePageResponseDto>(
    {
      getParams: getParams,
      endpoint: RentalManagerUserPropertyRentGuaranteeWebApiHandler_getRentalProtectionManagePageMultiplePolicies_Path,
      method: 'GET',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerUserPropertyRentGuaranteeWebApiHandler_getRentalProtectionPolicyCostByPolicyId_Path =
  '/api/web/v1/users/properties/rentGuarantee/getRentalProtectionPolicyCostByPolicyId';

/**
 * get rental protection policy cost by policyId
 * @deprecated
 */
export const RentalManagerUserPropertyRentGuaranteeWebApiHandler_getRentalProtectionPolicyCostByPolicyId = (
  getParams: GetRentalProtectionPolicyCostByPolicyIdParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<
    GetRentalProtectionPolicyCostByPolicyIdParams,
    never,
    GetRentalProtectionPolicyCostByPolicyIdResponseDto
  >(
    {
      getParams: getParams,
      endpoint: RentalManagerUserPropertyRentGuaranteeWebApiHandler_getRentalProtectionPolicyCostByPolicyId_Path,
      method: 'GET',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerUserPropertyRentGuaranteeWebApiHandler_getRentalProtectionStateForListingMultiPolicy_Path =
  '/api/web/v1/users/properties/rentGuarantee/getRentalProtectionStateForListingMultiPolicy';

/**
 * Get rental protection state for listingAlias for multi policy page
 * @deprecated
 */
export const RentalManagerUserPropertyRentGuaranteeWebApiHandler_getRentalProtectionStateForListingMultiPolicy = (
  getParams: GetRentalProtectionStateForListingMultiPolicyParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<
    GetRentalProtectionStateForListingMultiPolicyParams,
    never,
    RentGuaranteeListingStateResponseDto
  >(
    {
      getParams: getParams,
      endpoint: RentalManagerUserPropertyRentGuaranteeWebApiHandler_getRentalProtectionStateForListingMultiPolicy_Path,
      method: 'GET',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerUserPropertyRentGuaranteeWebApiHandler_getSecureClaimsUrlForPolicy_Path =
  '/api/web/v1/users/properties/rentGuarantee/getSecureClaimsUrlForPolicy';

/**
 * get secure lease lock claims url for policy
 * @deprecated
 */
export const RentalManagerUserPropertyRentGuaranteeWebApiHandler_getSecureClaimsUrlForPolicy = (
  getParams: GetSecureClaimsUrlForPolicyParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<GetSecureClaimsUrlForPolicyParams, never, GetSecureClaimsUrlForPolicyResponseDto>(
    {
      getParams: getParams,
      endpoint: RentalManagerUserPropertyRentGuaranteeWebApiHandler_getSecureClaimsUrlForPolicy_Path,
      method: 'GET',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerUserPropertyRentGuaranteeWebApiHandler_retrieveStoredPaymentMethods_Path =
  '/api/web/v1/users/properties/rentGuarantee/stripe/retrieveStoredPaymentMethods';

/**
 * retrieve stored payment methods for user
 * @deprecated
 */
export const RentalManagerUserPropertyRentGuaranteeWebApiHandler_retrieveStoredPaymentMethods = (
  client = getClient(),
) => {
  return httpFrontEndRequest<never, never, RetrieveStoredPaymentMethodsResponseDto>(
    {
      endpoint: RentalManagerUserPropertyRentGuaranteeWebApiHandler_retrieveStoredPaymentMethods_Path,
      method: 'GET',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerUserPropertyRentGuaranteeWebApiHandler_savePolicyPaymentMethod_Path =
  '/api/web/v1/users/properties/rentGuarantee/stripe/savePolicyPaymentMethod';

/**
 * save Stripe payment method for policy
 * @deprecated
 */
export const RentalManagerUserPropertyRentGuaranteeWebApiHandler_savePolicyPaymentMethod = (
  postData: SavePolicyPaymentMethodRequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, SavePolicyPaymentMethodRequestDto, void>(
    {
      endpoint: RentalManagerUserPropertyRentGuaranteeWebApiHandler_savePolicyPaymentMethod_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
      postData: postData,
    },
    client,
  );
};
